import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const WorkplaceContext = React.createContext();

export const useWorkplaceContext = () => useContext(WorkplaceContext);

export function WorkplaceProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/0b4873d0-a469-433b-b33e-1bd03808a4db').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/c3994104-e2fc-465b-a121-58a5855b1529')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <WorkplaceContext.Provider value={value}>{children}</WorkplaceContext.Provider>;
}
